import React from 'react'
import classnames from 'classnames'

import styles from './styles.module.scss'

interface Props extends React.PropsWithChildren {
  className?: string
  noScrollClassName?: string
  onClose: () => void
}

const ModalWrapper: React.FC<Props> = ({
  children,
  className,
  noScrollClassName = 'no-scroll',
  onClose,
}) => {
  const clickOutside = React.useCallback(
    (event: MouseEvent) => {
      if (!event.target) {
        return
      }

      const target = event.target as HTMLElement
      const clickWasOutsideModal = !(target as HTMLElement).closest('#modal')
      // The button that was clicked could be removed from the DOM
      // at this point and we don't want that to dismiss the modal.
      const elementIsInDOM = document.body.contains(target)

      if (clickWasOutsideModal && elementIsInDOM) {
        document.body.classList.remove(noScrollClassName)
        onClose()
      }
    },
    [noScrollClassName, onClose],
  )

  React.useEffect(() => {
    document.body.classList.add(noScrollClassName)
    document.addEventListener('mouseup', clickOutside)

    return () => {
      document.body.classList.remove(noScrollClassName)
      document.removeEventListener('mouseup', clickOutside)
    }
  }, [])

  return (
    <div className={classnames(styles.wrapper, className)}>
      <div>{children}</div>
    </div>
  )
}

export default ModalWrapper
